import {
  usedremaining,
  //autopercent,
  autopercent_tyndall,
  budgetemptiedyear,
  budgetfractionconsumedyear,
} from "@js/scenario";
import { roundn } from "@js/utils";
import { fractionFromDecimal } from "@js/fillTemplateHelpers";
import { trend } from "@js/trend";

export default function datavariables(data, first_year, currentyear) {
  let emissions = data.municipality.emissions._sum._sum;
  let budget = data.municipality.budget;

  let time_axis = { first_year: first_year, last_year: currentyear };

  let [lastemission, used, remaining_tons] = usedremaining(
    emissions,
    time_axis,
    currentyear,
    budget
  );

  let remainingBudget = remaining_tons;
  let remainingBudgetDecimalConsumedPerYear = lastemission / remaining_tons;
  let remainingBudgetFractionConsumedPerYear = fractionFromDecimal(
    remainingBudgetDecimalConsumedPerYear
  );
  let scenarioRecommendedPercent = autopercent_tyndall(
    lastemission,
    remaining_tons
  );
  let scenarioRecommendedPercentRounded = roundn(scenarioRecommendedPercent, 1);

  //let trend_first_year = currentyear - 4;
  //let trend_last_year = currentyear - 1;
  //actually, dont make this depend on currentyear.
  let trend_first_year = 2016;
  let trend_last_year = 2019;

  let [yearlyChange, extrapolatedPercent] = trend(
    data.years,
    emissions,
    trend_first_year,
    trend_last_year
  );

  let [trendbudgetempiedyear, trendbudgetempiedyearsrem] = budgetemptiedyear(
    extrapolatedPercent,
    emissions,
    currentyear,
    time_axis,
    remainingBudget
  );

  let [
    withoutchangebudgetempiedyear,
    withoutchangebudgetempiedyearsrem,
  ] = budgetemptiedyear(0, emissions, currentyear, time_axis, remainingBudget);

  let [
    recommended_budget90PercentConsumedYear,
    recommended_budget90PercentConsumedYearsRem,
  ] = budgetfractionconsumedyear(
    scenarioRecommendedPercent,
    emissions,
    currentyear,
    time_axis,
    remainingBudget,
    0.9
  );

  let [
    recommended_budget95PercentConsumedYear,
    recommended_budget95PercentConsumedYearsRem,
  ] = budgetfractionconsumedyear(
    scenarioRecommendedPercent,
    emissions,
    currentyear,
    time_axis,
    remainingBudget,
    0.95
  );

  const scenarioRecommended = {
    percent: scenarioRecommendedPercentRounded,
    budget90PercentConsumedYear: recommended_budget90PercentConsumedYear,
    budget90PercentConsumedYearsRemaining: recommended_budget90PercentConsumedYearsRem,
    budget95PercentConsumedYear: recommended_budget95PercentConsumedYear,
    budget95PercentConsumedYearsRemaining: recommended_budget95PercentConsumedYearsRem,
  };

  const scenarioTrend = {
    first_year: trend_first_year,
    last_year: trend_last_year,
    yearlyChange,
    extrapolatedPercent,
    budgetEmptyYear: trendbudgetempiedyear,
    budgetEmptyYearsRemaining: trendbudgetempiedyearsrem,
  };

  const scenarioWithoutChange = {
    extrapolatedPercent: 0,
    budgetEmptyYear: withoutchangebudgetempiedyear,
    budgetEmptyYearsRemaining: withoutchangebudgetempiedyearsrem,
    remainingBudgetFractionConsumedPerYear,
    remainingBudgetDecimalConsumedPerYear,
  };

  const variables = {
    firstYear: first_year,
    currentYear: currentyear,
    sumEmissionsSinceFirstYear: used,
    remainingBudget,
    scenarioRecommended,
    scenarioTrend,
    scenarioWithoutChange,
  };

  return variables;
}
